export default __webpack_public_path__ + "static/media/feather-upload-cloud.9b00805c.svg";